import { render, staticRenderFns } from "./RiskProfiling.vue?vue&type=template&id=51f827fe&scoped=true"
import script from "./RiskProfiling.vue?vue&type=script&lang=js"
export * from "./RiskProfiling.vue?vue&type=script&lang=js"
import style0 from "./RiskProfiling.vue?vue&type=style&index=0&id=51f827fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f827fe",
  null
  
)

export default component.exports